import { createRoute } from '@tanstack/react-router';
import { PostaList } from '@/modules/posta/PostaList';
import { parsePostaSearch } from '@/modules/posta/helpers';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/posta',
  component: PostaList,
  validateSearch: parsePostaSearch,
});
